/**
 * Small counts written as words, for prose.
 *
 * Needed because the copy that quotes a count derives it rather than typing
 * it — "seven services" has to stay true if one is ever added to the
 * catalogue — and a derived count interpolated raw gives "7 services and one
 * team" in a sentence whose next clause spells "one". House style is to spell
 * small numbers in prose and leave figures to the data, so this closes the gap
 * between the two.
 *
 * Ten is the usual cut-off for the rule and twelve is where the words stop
 * being shorter than the figure; past that the numeral is returned, which is
 * also what the style guides say to do.
 */
const words = [
  'zero',
  'one',
  'two',
  'three',
  'four',
  'five',
  'six',
  'seven',
  'eight',
  'nine',
  'ten',
  'eleven',
  'twelve',
] as const;

/** `8` → `'eight'`, `13` → `'13'`. Negative and fractional values pass through. */
export function spellCount(n: number): string {
  return Number.isInteger(n) && n >= 0 && n < words.length ? words[n] : String(n);
}

/** The same, capitalised for the start of a sentence. `8` → `'Eight'`. */
export function spellCountSentence(n: number): string {
  const word = spellCount(n);
  return word.charAt(0).toUpperCase() + word.slice(1);
}
